import { stripTimezone } from '../../helpers/date_helpers';

export const toDateString = (date: Date) => {
	return stripTimezone(date.toISOString());
};
